export default __webpack_public_path__ + "static/media/utpal.575ae5b4.jpeg";